// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import TSOAuthDetector from './components/TSOAuthDetector';
import Dashboard from './pages/Dashboard';
import Game from './pages/Game';
import Collection from './pages/Collection';
import './App.css';
import DeckBuilder from './components/DeckBuilder';

// Protected route wrapper
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }
  
if (!isAuthenticated) {
  // window.location.href = 'https://accounts.shieldedonion.co.uk';
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-white">Debug: Not authenticated - check console</div>
    </div>
  );
}
  
  return <>{children}</>;
};

// Main app content
const AppContent: React.FC = () => {
  return (
    <div className="App">
      <TSOAuthDetector />
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/game/:gameId" 
          element={
            <ProtectedRoute>
              <Game />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/collection" 
          element={
            <ProtectedRoute>
              <Collection />
            </ProtectedRoute>
          } 
        />
		<Route path="/deck-builder" element={<DeckBuilder />} />

        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;